import { useContext } from 'react';
import { ThemePreferenceContext } from '../context/ThemePreferenceContext';
import type { ThemePreference } from '../context/ThemePreferenceContext';

export type { ThemePreference };

export function useThemePreference() {
  const context = useContext(ThemePreferenceContext);
  if (!context) {
    throw new Error('useThemePreference must be used within ThemePreferenceProvider');
  }
  return context;
}
